import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { findUsuarioCartaoCreditoByCurrentUser } from "./api-usuario-cartao-credito";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import UsuarioCartaoCreditoList from "./UsuarioCartaoCreditoList";
import Loading from "../UI/Loading";
import Button from "../UI/Button";
import { Link } from 'react-router-dom';

const UsuarioCartaoCreditoContainer = () => {
    const [listUsuarioCartaoCredito, setListUsuarioCartaoCredito] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        findUsuarioCartaoCreditoByCurrentUser().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListUsuarioCartaoCredito(data);
                }
            }
            setIsLoading(false);
        })
    }, []);

    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                {isLoading ? <Loading description='Carregando lista...' /> :
                    <UsuarioCartaoCreditoList listUsuarioCartaoCredito={listUsuarioCartaoCredito} />
                }
            </Grid>
            <Grid size={12}>
                <Button
                    component={Link}
                    to="/insere-novo-cartao-credito"
                >Inserir Novo Cartão</Button>
            </Grid>
        </Grid>
    );
}

export default UsuarioCartaoCreditoContainer;